import React, { useEffect } from 'react'
import { checkConnectAccountStatus } from 'features/giving/givingSlice'
import { useDispatch, useSelector } from 'react-redux'
import { SettingsMainContainer } from '../settings.styled'
import VerifiedConnectAccount from './VerifiedConnectAccount'
import RequirementsDue from './RequirementsDue'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

export default function ChurchConnectAccount() {
    const { t } = useTranslation('giving')
    const dispatch = useDispatch()
    const {
        connectAccount,
        churchConnectAccountStatusLoading,
        churchConnectAccountStatusSuccess,
        churchConnectAccountStatusError,
        churchConnectAccountStatusMessage,
    } = useSelector(state => state.giving)

    useEffect(() => {
        dispatch(checkConnectAccountStatus())
    }, [dispatch])

    if (churchConnectAccountStatusLoading) {
        return (
            <SettingsMainContainer>
                <CenteredStatus>{t('admin.checking')}</CenteredStatus>
            </SettingsMainContainer>
        )
    }

    if (churchConnectAccountStatusError) {
        return (
            <SettingsMainContainer>
                <CenteredStatus>{churchConnectAccountStatusMessage || t('admin.setupError')}</CenteredStatus>
            </SettingsMainContainer>
        )
    }

    if (churchConnectAccountStatusSuccess && connectAccount?.payouts_enabled === false) {
        return <RequirementsDue />
    }

    if (churchConnectAccountStatusSuccess && connectAccount?.payouts_enabled) {
        return <VerifiedConnectAccount />
    }

    return <RequirementsDue />
}

const CenteredStatus = styled.div`
    width: 100%;
    min-height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    font-size: 14px;
`
